import { GfsAssessmentEditor } from "@/services/backend/gfs/assessment/components/assessment-editor";

export default function GfsAssessmentRoute() {
  return <GfsAssessmentEditor />;
}
